export default {
  strict: true,
  namespaced: true,
  state: {
    driverOutbound: {
      list: [],
      maxList: 0,
      currentPage: 1,
      perPage: 20,
      orderAsc: 1,
      isLoading: false,
      licenseType: 'all'
    }
  },
  mutations: {
    resetDriverOutboundList (state) { state.driverOutbound.list = [] },
    addDriverOutbound (state, value) { state.driverOutbound.list.push(value) },
    setDriverOutboundIsLoading (state, value) { state.driverOutbound.isLoading = value },
    setDriverOutboundLicenseType (state, value) { state.driverOutbound.licenseType = value },
    setDriverOutboundCurrentPage (state, value) { state.driverOutbound.currentPage = value },
    setDriverOutboundMaxList (state, value) { state.driverOutbound.maxList = value }
  }
};



// WEBPACK FOOTER //
// ./src/store/laxit/driver-outbound.js